<script>
import {VueMaskDirective as mask} from 'v-mask'
import service, {uploadFotoGrvIndividual, verificaNumeroGrv} from '../../../../domain/grv/services'
import {isArray, debounce} from 'lodash'
import moment from 'moment'
import BtnCheckPossui from './CheckPossui'
import Vue from 'vue'
import {GRV_DETRO, GRV_ESPIRITO_SANTO} from '../../../../domain/grv/helpers/tipos-grv'
import {mockExtraModelDataHora} from '../../../../domain/grv/helpers/grv-mock'
import ArquivosGrv from './grv/ArquivosGrv'
import LacresGrv from './grv/LacresGrv'
import TituloSecao from './grv/TituloSecao'
import {listByContrato} from '../../../../domain/bem-categoria/services/categorias-veiculares'
import {mapGetters} from 'vuex'
import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'

const POSSUI = '1'
const NAO_POSSUI = '2'
const NAO_MARCA = '5'

let templateEquipamento = {id: null, possui: true, equipamento: {id: null, nome: null}}

export default {
  nome: 'grv',
  components: {
    TituloSecao,
    LacresGrv,
    ArquivosGrv,
    BtnCheckPossui
  },
  directives: {mask},
  mixins: [AclCheckMixins],
  data () {
    return {
      isGgv: false,
      dataRequired: {
        equipamentos: []
      },
      dataRequiredLoaded: false,
      extraModel: JSON.parse(JSON.stringify(mockExtraModelDataHora)),
      data: {
        id: null,
        numero: null,
        ano: null,
        bairroApreensao: null,
        chassi: null,
        numeroMotor: null,
        chavesVeiculo: 1,
        numeroChave: null,
        cidadeApreensao: null,
        cidadeCondutor: null,
        codigoInfracao: null,
        equipamentos: [],
        motivoInfracaoOutros: null,
        marca: null,
        modelo: null,
        cor: null,
        vaga: null,
        cpfCondutor: null,
        data: null,
        dataApreensao: null,
        enderecoApreensao: null,
        enderecoCondutor: null,
        estadoCondutor: null,
        lacres: [],
        matriculaAgenteApreensor: null,
        nivelCombustivel: null,
        nomeAgenteApreensor: null,
        nomeCondutor: null,
        numeroAutoInfracao: null,
        observacoes: null,
        orgaoEmissorRgCondutor: null,
        placa: null,
        sucata: false,
        renavam: null,
        rgCondutor: null,
        telefoneCondutor: null,
        tipoOperacao: 2,
        tipoRemocao: 2,
        volumesInteriorVeiculo: null,
        comRubrica: null,
        rubrica: null,
        comAssinaturaCondutor: null,
        assinaturaCondutor: null,
        condutorRecusouAssinar: null,
        comAssinaturaTestemunha: null,
        condutorPresente: null,
        ufApreensao: null,
        orgaoApreensor: null,
        reboque: null,
        reboquista: null,
        contrato: null,
        bemCategoria: null,
        patio: null,
        kmForaDaCidade: null,
        kmInicialDoReboque: 0,
        kmFinalDoReboque: 0,
        complementoApreensao: null,
        complementoCondutor: null,
        codigoGrv: null,
        liberarPorDecisaoJudicial: false,
        liberarPorPrensa: false,
        liberarPorRouboFurto: false,
        arquivos: [],
        numeracaoManual: false
      },
      cache: {
        numeroGrv: null
      },
      ggv: {
        conforme: false
      },
      edit: false,
      isLoading: false,
      cadastroError: null,
      atualizadoSucesso: null,
      GRV_ESPIRITO_SANTO,
      tipoGrv: this.$route.query.tipoGrv
    }
  },
  computed: {
    ...mapGetters(['isLogged', 'currentUser']),
    isFromSolicitacao () {
      const {tipoGrv, solicitacao} = this.$route.query
      return +solicitacao && +tipoGrv === GRV_ESPIRITO_SANTO
    },
    kmTotal () {
      return (Number(this.data.kmFinalDoReboque) - Number(this.data.kmInicialDoReboque))
    },
    // TODO: mover para GrvMixins
    isGrvRegistrada () {
      return this.$route.params.id && this.$route.params.id !== 'registrar'
    },
    podeEditarCampoPatio () {
      return !this.isGrvRegistrada || [
        5, // rhenrique
        488, // tiagofelipe
        22799, // gabrielmiranda
        23048, // lucianalou
        1570, // fnascimento
        42208, // biancarocha
        23108 // felipehaubrick
      ].some(id => id === this.currentUser.id)
    }
  },
  watch: {
    'data.numeracaoManual': function (v) {
      this.data.numero = this.cache.numeroGrv
      if (v) {
        this.$nextTick(() => {
          this.$refs.numeroGrv.focus()
        })
      }
    }
  },
  mounted () {
    this.loadData()
  },
  activated () {
  },
  destroyed () {
  },
  methods: {
    loadData () {
      this.$loaderOverlay.open().message('Carregando dados relacionados')
      service.dataRequired(this.$route.query.tipoGrv)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.dataRequiredLoaded = true
          this.dataRequired = response.data
          this.dataRequired.equipamentos = this.dataRequired.equipamentos.filter(equipamento => !equipamento.policiaCivil)
          if (isArray(this.dataRequired.equipamentos) && this.dataRequired.equipamentos.length > 0) {
            for (let i = 0; i < this.dataRequired.equipamentos.length; i++) {
              // this.$set(this.dataRequired.equipamentos[i], 'checked', false)
              // this.$set(this.dataRequired.equipamentos[i], 'possui', false)
              Vue.util.defineReactive(this.dataRequired.equipamentos[i], 'checked', false)
              Vue.util.defineReactive(this.dataRequired.equipamentos[i], 'possui', NAO_MARCA)
            }
          }
          // this.data.numero = this.dataRequired.sequencialGrv
          this.start()
          console.log(response)
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    start () {
      this.clearInputFiles()
      if (this.$route.params.id && this.$route.params.id !== 'registrar') {
        this.edit = true
        this.$loaderOverlay.open().message('Carregando GRV')
        if (typeof this.$route.query.ggv !== 'undefined') {
          this.isGgv = true
        }
        service.find(this.$route.params.id, this.isGgv)
          .then((response) => {
            this.$loaderOverlay.hide()
            let data = response.data
            this.cache.numeroGrv = data.numero
            data.reboque = data.reboque ? data.reboque.id : null
            data.orgaoApreensor = data.orgaoApreensor ? data.orgaoApreensor.id : null
            data.reboquista = data.reboquista ? data.reboquista.id : null
            data.bemCategoria = data.bemCategoria ? data.bemCategoria.id : null
            data.patio = data.patio ? data.patio.id : null
            data.contrato = data.contrato ? data.contrato.id : null
            data.cpfCondutor = data.cpfCondutor ? data.cpfCondutor.replace(/\D/g, '') : null

            // SUPORTE A GRV DO ESPIRITO SANTO
            data.solicitacao = data.solicitacao ? data.solicitacao.id : null

            let dataRemocao = JSON.parse(JSON.stringify(data.data))
            this.extraModel.dataRemocao = moment(dataRemocao.date).format('L')
            this.extraModel.horaRemocao = moment(dataRemocao.date).format('LT')
            let dataApreensao = JSON.parse(JSON.stringify(data.dataApreensao))
            this.extraModel.dataApreensao = moment(dataApreensao.date).format('L')
            this.extraModel.horaApreensao = moment(dataApreensao.date).format('LT')

            /* if (isArray(data.equipamentos) && data.equipamentos.length > 0) {
              this.dataRequired.equipamentos.forEach((e) => {
                let find = data.equipamentos.findIndex((e1) => e1.equipamento.id === e.id)
                if (typeof find !== 'undefined' && find !== -1) {
                  e.checked = true
                  e.possui = data.equipamentos[find].equipamento.possui
                }
              })
            } */
            if (isArray(data.equipamentos) && data.equipamentos.length > 0) {
              data.equipamentos = data.equipamentos.map(item => {
                item.equipamento.possui = item.possui
                return item.equipamento
              })
              this.dataRequired.equipamentos.forEach((e) => {
                let find = data.equipamentos.findIndex((e1) => e1.id === e.id)
                if (typeof find !== 'undefined' && find !== -1) {
                  e.checked = true
                  e.possui = data.equipamentos[find].possui
                  data.equipamentos[find] = e
                }
              })
            }
            this.data = data
            this.listCategoriasBem()
            console.log(response)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      }
    },
    clearInputFiles () {
      if (this.$refs.fileInptImg) this.$refs.fileInptImg.value = ''
      if (this.$refs.fileInptImgCelular) this.$refs.fileInptImgCelular.value = ''
    },
    submit () {
      if ((this.data.codigoInfracao || '').length > 8) {
        window.alert('Código de confirmação deve ter no máximo 8 caracteres.')
        this.$refs.codigoInfracao.focus()
        return
      }
      if (this.isGgv) {
        let confirm = window.confirm('Tem certeza que deseja gerar a GGV?')
        if (!confirm) return
      }
      this.cadastroError = null
      this.$loaderOverlay.open().message('Processando')
      this.$bar.start()
      window.setTimeout(() => {
        this.$loaderOverlay.message('Aguarde, registrando GRV...')
      }, 1000)
      let data = JSON.parse(JSON.stringify(this.data))
      data.data = this.extraModel.dataRemocao + ' ' + this.extraModel.horaRemocao
      data.dataApreensao = this.extraModel.dataApreensao + ' ' + this.extraModel.horaApreensao
      data.cpfCondutor = data.cpfCondutor ? data.cpfCondutor.replace(/\D/g, '') : null
      if (this.isGgv) {
        data.isGgv = true
        data.ggv = this.ggv
      }
      data.equipamentos = data.equipamentos.map(equip => {
        equip.possui = equip.possui ? POSSUI : NAO_POSSUI
        return equip
      })

      data.arquivos = data.arquivos.filter(file => !file.fromCelular)

      // SUPORTE A GRV DO ESPÍRITO SANTO
      const {solicitacao} = this.$route.query

      if (this.isFromSolicitacao) {
        data.solicitacao = solicitacao
      }

      service.cadastro(data, this.$route.params.id, this.$route.query.tipoGrv || GRV_DETRO).then((response) => {
        let callbackEnd = () => {
          this.uploadFotoIndividualGrv(response.data.id)
            .then(() => {
              this.formdataFotosParaUpload = []
              this.$bar.finish()
              this.$loaderOverlay.hide()
              if (this.$route.params.id) {
                this.start()
                this.atualizadoSucesso = true
                this.$el.querySelector('#sucessMsg').focus()
              } else {
                alert('GRV cadastrada com sucesso.')
                this.loadData()
                // Redirecionar para tela de visualização da grv criada
                this.$router.push({name: 'grv.visualizar', params: {id: response.data.id}})
                this.goToTop()
              }
            })
        }
        callbackEnd()
      }).catch((response) => {
        this.$bar.finish()
        this.$loaderOverlay.hide()
        this.cadastroError = response.data.errors
        this.$nextTick(() => {
          this.$refs.error.focus()
        })
        console.log(response)
      })
    },
    uploadFotoIndividualGrv: async function (grvId) {
      this.$loaderOverlay.message('Cadastrando as fotos, aguarde...')
      let counter = 0
      for (let file of this.data.arquivos) {
        if (file.apagar || !file.arquivo) continue
        ++counter
        this.$loaderOverlay.message(`Cadastrando foto ${counter} de ${(this.data.arquivos || []).length}, aguarde...`)
        try {
          await uploadFotoGrvIndividual(grvId, {data: file.arquivo, filename: 'fotoGrv'})
        } catch (error) {
          console.log('DEU RUIM', error)
        }
      }
      return new Promise(resolve => resolve(console.log('ENVIOU TODAS AS FOTOS!')))
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    },
    marcaEquipamento (e, v) {
      let template = JSON.parse(JSON.stringify(templateEquipamento))
      // this.$set(this.dataRequired.equipamentos[this.dataRequired.equipamentos.indexOf(v)], 'checked', e.target.checked)
      v.checked = e.target.checked
      if (e.target.checked) {
        // template.possui = v.possui
        template = v
        this.$set(template, 'possui', v.possui)
        /* Object.defineProperty(template, 'possui', {
          get () {
            return template.possui
          }
        }) */
        // delete template.equipamento.possui
        this.data.equipamentos.push(template)
      } else {
        this.data.equipamentos = this.data.equipamentos.filter((e) => {
          // return e.equipamento.id !== v.id
          return e.id !== v.id
        })
      }
      console.log(this.data.equipamentos)
    },
    consultaPlacaChassi () {
      this.$loaderOverlay.open().message('Carregando dados do veículo')

      service.consultaPlacaChassi(this.data)
        .then((response) => {
          console.log(response)
          this.$loaderOverlay.hide()
          // result = JSON.parse(response.data)
          let data = JSON.parse(response.data)
          if (data.Retorno === 'OK') {
            this.data.placa = data.Placa
            this.data.chassi = data.Chassi
            this.data.marca = data.DescricaoMarca
            this.data.modelo = data.DescricaoTipo
            this.data.cor = data.DescricaoCor
            this.data.renavam = data.NumeroRenavam
            this.data.ano = data.AnoFabricacao

            if (data.Classificacao === 'LA') {
              this.data.bemCategoria = 1
            } else if (data.Classificacao === 'LB') {
              this.data.bemCategoria = 2
            } else if (data.Classificacao === 'LC') {
              this.data.bemCategoria = 3
            } else if (data.Classificacao === 'PD') {
              this.data.bemCategoria = 4
            }
          } else {
            alert(data.Retorno)
          }
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          alert(response.Retorno)
        })
    },
    verificaNumeroGrv: debounce(function () {
      if (!this.data.numero) return
      const numero = (this.data.numero || '').replace(/\D/g, '')
      if (!numero || numero.length < 3) return
      if (numero === this.cache.numeroGrv) return
      console.log('verificando número grv')
      verificaNumeroGrv(numero)
        .then(response => {
          const {existe} = response.data
          if (existe) alert('Já existe uma GRV cadastrada com esse número')
        })
    }, 600),
    goToTop () {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    },
    listCategoriasBem () {
      listByContrato(this.data.contrato)
      .then(response => {
        this.dataRequired.categoriaBem = response.data
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="dataRequiredLoaded" ref="primeiraDiv">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">
            <titulo-secao class="bg-warning text-black" v-if="isGgv">
              <strong>GGV</strong><br>
              Você está fazendo a vistoria para guarda deste veículo
            </titulo-secao>
            <titulo-secao v-else>GRV</titulo-secao>
          </div>

          <div class="panel panel-default">
            <div class="clearfix">
              <div>
                <form v-on:submit.prevent="submit" class="bs-example form-horizontal form-grv">
                  <div class="wrapper">
                    <div class="panel-body">
                      <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                        <div class="m-b-sm font-bold">Erro ao registrar a GRV, corrija e tente novamente</div>
                        <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
                      </div>
                      <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
                      <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null" class="alert alert-success">
                        <div class="font-bold">Atualizado com sucesso!</div>
                      </div>
                      <div class="form-group">
                        <label for="grv" class="col-sm-2 control-label">GRV</label>
                        <div class="col-sm-10">
                          <input
                            :disabled="!data.numeracaoManual"
                            id="grv"
                            type="text"
                            v-model="data.numero"
                            class="form-control"
                            @blur="verificaNumeroGrv"
                            @keyup="data.numero = data.numero.replace(/\D/g, '')"
                            ref="numeroGrv"
                          />
                          <label for="numeracaoManual" class="i-checks m-t-xs">
                            <input v-model="data.numeracaoManual" type="checkbox" id="numeracaoManual"
                                   tabindex="0" aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="numeracaoManual">Inserir número da GRV manualmente</label>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dataApreensao" class="col-sm-2 control-label">Data da apreensão</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input required id="dataApreensao" placeholder="dd/mm/yyyy"
                                     v-model="extraModel.dataApreensao"
                                     v-mask="'##/##/####'" type="text" class="form-control"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="horaApreensao" class="col-sm-4 control-label">Hora da apreensão</label>
                                <div class="col-sm-8">
                                  <input required id="horaApreensao" placeholder="00:00"
                                         v-model="extraModel.horaApreensao"
                                         v-mask="'##:##'" type="time" class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="dataRemocao" class="col-sm-2 control-label">Data de remoção</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input required id="dataRemocao" placeholder="dd/mm/yyyy" v-model="extraModel.dataRemocao"
                                     v-mask="'##/##/####'" type="text" class="form-control"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="horaRemocao" class="col-sm-4 control-label">Hora de remoção</label>
                                <div class="col-sm-8">
                                  <input required id="horaRemocao" placeholder="00:00" v-model="extraModel.horaRemocao"
                                         v-mask="'##:##'" type="time" class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Pátio</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <select id="patio" required v-model="data.patio" class="form-control" :disabled="!podeEditarCampoPatio">
                                <option :value="null">Selecione</option>
                                <option :value="patio.id" v-for="patio in dataRequired.patios" :key="patio.id">
                                  {{patio.nome}}
                                </option>
                              </select>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label class="col-sm-4 control-label">Contrato</label>
                                <div class="col-sm-8">
                                  <select id="contrato" required v-model="data.contrato" class="form-control" :disabled="isGgv" @change="listCategoriasBem">
                                    <option :value="null">Selecione</option>
                                    <option :value="contrato.id" v-for="contrato in dataRequired.contratos"
                                            :key="contrato.id">{{contrato.nome}}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- FOR EDIT -->
                      <div>
                        <div class="form-group">
                          <div class="col-sm-offset-2 col-sm-10">
                            <label for="liberarJudicial" class="i-checks m-b-none">
                              <input v-model="data.liberarPorDecisaoJudicial" type="checkbox" id="liberarJudicial"
                                     tabindex="0" aria-checked="false"
                                     aria-invalid="false"><i></i>
                            </label>
                            <label for="liberarJudicial">Liberar para Retirada por Decisão Judicial</label>
                          </div>
                        </div><!---->

                        <div class="form-group">
                          <div class="col-sm-offset-2 col-sm-10">
                            <label for="liberarPrensa" class="i-checks m-b-none">
                              <input v-model="data.liberarPorPrensa" type="checkbox" id="liberarPrensa" tabindex="0"
                                     aria-checked="false"
                                     aria-invalid="false"><i></i>
                            </label>
                            <label for="liberarPrensa">Liberar para Retirada por Prensa</label>
                          </div>
                        </div><!---->

                        <div class="form-group">
                          <div class="col-sm-offset-2 col-sm-10">
                            <label for="liberarRoubo" class="i-checks m-b-none">
                              <input v-model="data.liberarPorRouboFurto" type="checkbox" id="liberarRoubo" tabindex="0"
                                     aria-checked="false"
                                     aria-invalid="false"><i></i>
                            </label>
                            <label for="liberarRoubo">Liberar para Retirada por Roubo/Furto</label>
                          </div>
                        </div><!---->
                      </div>
                    </div><!-- END Padding -->
                  </div>

                  <titulo-secao>Local de Apreensão</titulo-secao>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="enderecoApreensao" class="col-sm-2 control-label">Endereço</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-7">
                              <input required id="enderecoApreensao" type="text" v-model="data.enderecoApreensao"
                                     class="form-control"/>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="bairroApreensao" class="col-sm-4 control-label">Bairro</label>
                                <div class="col-sm-8">
                                  <input required id="bairroApreensao" type="text" v-model="data.bairroApreensao"
                                         class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="complementoApreensao" class="col-sm-2 control-label">Complemento</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-4">
                              <input id="complementoApreensao" v-model="data.complementoApreensao" type="text"
                                     class="form-control"/>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label for="ufApreensao" class="col-sm-4 control-label">UF</label>
                                <div class="col-sm-8">
                                  <input id="ufApreensao" type="text" v-model="data.ufApreensao" class="form-control"/>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="cidadeApreensao" class="col-sm-4 control-label">Cidade</label>
                                <div class="col-sm-8">
                                  <input required id="cidadeApreensao" type="text" v-model="data.cidadeApreensao" class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Dados do Veículo</titulo-secao>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label for="sucata" class="i-checks m-b-none">
                            <input v-model="data.sucata" type="checkbox" id="sucata"
                                   tabindex="0" aria-checked="false"
                                   aria-invalid="false"><i></i>
                          </label>
                          <label for="sucata">Sucata</label>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="placa" class="col-sm-2 control-label">Placa</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="placa" type="text" v-model="data.placa" class="form-control"/>
                            </div>
                            <div class="col-sm-7">
                              <button class="btn btn-info btn-sm m-l-xs btn-colsultaGrv" type="button" @click="consultaPlacaChassi" v-if="!isRestritoVisitante">Consultar</button>
                              <!-- TODO: -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="chassi" class="col-sm-2 control-label">Chassi</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="chassi" type="text" v-model="data.chassi" class="form-control"/>
                            </div>
                            <div class="col-sm-7">
                              <button class="btn btn-info btn-sm m-l-xs btn-colsultaGrv" type="button" @click="consultaPlacaChassi" v-if="!isRestritoVisitante">Consultar</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="numeroMotor" class="col-sm-2 control-label">Número do motor</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="numeroMotor" v-model="data.numeroMotor" type="text" class="form-control"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label class="col-sm-4 control-label">Categoria</label>
                                <div class="col-sm-8">
                                  <select id="categoria" required v-model="data.bemCategoria" class="form-control">
                                    <option :value="null">Selecione</option>
                                    <option :value="categoriaBem.id" v-for="categoriaBem in dataRequired.categoriaBem"
                                            :key="categoriaBem.id">{{categoriaBem.nome}}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="marca" class="col-sm-2 control-label">Marca/Modelo</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="marca" v-model="data.marca" type="text" class="form-control"/>
                            </div>
                            <div class="col-sm-7">
                              <div class="form-group">
                                <label for="modelo" class="col-sm-4 control-label">Tipo</label>
                                <div class="col-sm-8">
                                  <input id="modelo" type="text" v-model="data.modelo" class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="cor" class="col-sm-2 control-label">Cor</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="cor" type="text" v-model="data.cor" class="form-control"/>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="vaga" class="col-sm-4 control-label">Vaga</label>
                                <div class="col-sm-8">
                                  <input id="vaga" v-model="data.vaga" type="text" class="form-control"/>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label for="ano" class="col-sm-4 control-label">Ano</label>
                                <div class="col-sm-8">
                                  <input id="ano" type="text" v-model="data.ano" class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="chavesVeiculo" class="col-sm-2 control-label">Chave do veículo</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <select required id="chavesVeiculo" v-model="data.chavesVeiculo" class="form-control">
                                <option :value="1">Condutor</option>
                                <option :value="2">Depósito</option>
                              </select>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="numeroChave" class="col-sm-4 control-label">Número da chave</label>
                                <div class="col-sm-8">
                                  <input id="numeroChave" v-model="data.numeroChave" type="text" class="form-control"/>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label for="renavam" class="col-sm-4 control-label">Renavam</label>
                                <div class="col-sm-8">
                                  <input id="renavam" type="text" v-model="data.renavam" class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Dados do Reboque</titulo-secao>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="reboquista" class="col-sm-2 control-label">Reboquista</label>
                        <!--<div class="col-sm-10"> TODO: REBOCAR/PERFORM: Implementar seleção externa e input somente do ID ou Código
                          <input id="reboquista" v-model="data.reboquista.codigo" type="text" class="form-control"/>
                        </div>-->
                        <div class="col-sm-10">
                          <select id="reboquista" required v-model="data.reboquista" class="form-control">
                            <option :value="null">Selecione</option>
                            <option :value="reboquista.id" v-for="reboquista in dataRequired.reboquistas" :key="reboquista.id" :disabled="!reboquista.ativo">
                              {{reboquista.nome}} (#{{reboquista.codigo}}) <span style="font-size: small; color: red" v-if="!reboquista.ativo">(inativo)</span>
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="reboque" class="col-sm-2 control-label">Reboque</label>
                        <div class="col-sm-10">
                          <select id="reboque" required v-model="data.reboque" class="form-control">
                            <option :value="null">Selecione</option>
                            <option :value="reboque.id" v-for="reboque in dataRequired.reboques" :key="reboque.id" :disabled="!reboque.ativo">
                              {{reboque.placa}} <span style="font-size: small; color: red" v-if="!reboque.ativo">(inativo)</span>
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="kmForaCidade" class="col-sm-2 control-label">KM fora cidade</label>
                        <div class="col-sm-10">
                          <input id="kmForaCidade" v-model="data.kmForaDaCidade" type="text" class="form-control" />
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="kmInicial" class="col-sm-2 control-label">KM inicial</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="kmInicial" v-model="data.kmInicialDoReboque" type="text" class="form-control" :required="tipoGrv === GRV_ESPIRITO_SANTO"/>
                              <small class="col-sm-offset-2 col-sm-10">KM inicial do reboque ao atender o acionamento.</small>
                            </div>
                            <div class="col-sm-5">
                              <div class="form-group">
                                <label for="kmFinal" class="col-sm-2 control-label">KM final</label>
                                <div class="col-sm-10">
                                  <input id="kmFinal" v-model="data.kmFinalDoReboque" type="text" class="form-control" :required="tipoGrv === GRV_ESPIRITO_SANTO"/>
                                  <small class="col-sm-offset-2 col-sm-10">KM final do reboque ao atender o acionamento.</small>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label for="kmTotal" class="col-sm-6 control-label">KM Total</label>
                                <div class="col-sm-6">
                                  <input id="kmTotal" :value="kmTotal" type="text" class="form-control" disabled/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Identificação do Condutor</titulo-secao>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="nomeCondutor" class="col-sm-2 control-label">Nome</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-8">
                              <input id="nomeCondutor" type="text" v-model="data.nomeCondutor" class="form-control"/>
                            </div>
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label for="telefoneCondutor" class="col-sm-4 control-label">Telefone</label>
                                <div class="col-sm-8">
                                  <input id="telefoneCondutor" v-model="data.telefoneCondutor" type="text" class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="cpfCondutor" class="col-sm-2 control-label">CPF</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="cpfCondutor" type="text" v-model="data.cpfCondutor" class="form-control" v-mask="'###.###.###-##'"/>
                            </div>
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label for="rgCondutor" class="col-sm-4 control-label">RG</label>
                                <div class="col-sm-8">
                                  <input id="rgCondutor" type="text" v-model="data.rgCondutor" class="form-control"/>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label for="orgaoEmissorRgCondutor" class="col-sm-4 control-label">Órgão Emissor</label>
                                <div class="col-sm-8">
                                  <input id="orgaoEmissorRgCondutor" type="text" v-model="data.orgaoEmissorRgCondutor"
                                         class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="enderecoCondutor" class="col-sm-2 control-label">Endereço</label>
                        <div class="col-sm-10">
                          <div class="row">
                            <div class="col-sm-5">
                              <input id="enderecoCondutor" type="text" v-model="data.enderecoCondutor"
                                     class="form-control"/>
                            </div>
                            <div class="col-sm-4">
                              <div class="form-group">
                                <label for="estadoCondutor" class="col-sm-4 control-label">UF</label>
                                <div class="col-sm-8">
                                  <input id="estadoCondutor" type="text" v-model="data.estadoCondutor"
                                         class="form-control"/>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label for="cidadeCondutor" class="col-sm-4 control-label">Cidade</label>
                                <div class="col-sm-8">
                                  <input id="cidadeCondutor" type="text" v-model="data.cidadeCondutor"
                                         class="form-control"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="col-sm-2 control-label">Assinatura</label>
                        <div class="col-sm-10">
                          <!-- TODO: Assinatura aqui -->
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" id="recusouAssinar" v-model="data.condutorRecusouAssinar" tabindex="0"
                                   aria-checked="false" aria-invalid="false"><i></i>
                          </label>
                          <label for="recusouAssinar">Condutor se recusou a assinar</label>
                        </div>
                      </div><!---->
                    </div>
                  </div>

                  <titulo-secao>Equipamentos / Acessórios</titulo-secao>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group b-b padder-v" v-for="equip in dataRequired.equipamentos" :key="equip.id">
                        <div class="col-sm-offset-2 col-sm-10">
                          <div class="row">
                            <div class="col-xs-4">
                              <label class="i-checks m-b-none">
                                <input v-model="equip.checked" @change="marcaEquipamento($event, equip)" type="checkbox"
                                       :id="equip.id"
                                       tabindex="0"
                                       aria-checked="false"
                                       aria-invalid="false"><i></i>
                              </label>
                              <label :for="equip.id">{{equip.nome}}</label>
                            </div>
                            <div class="col-xs-8">
                              <btn-check-possui v-model="equip.possui" v-show="equip.checked"/>
                            </div>
                          </div>
                        </div>
                      </div><!---->
                    </div>
                  </div>

                  <titulo-secao>Agente Apreensor</titulo-secao>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="nomeAgenteApreensor" class="col-sm-2 control-label">Nome do agente</label>
                        <div class="col-sm-10">
                          <input required id="nomeAgenteApreensor" type="text" v-model="data.nomeAgenteApreensor" class="form-control"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="matriculaAgenteApreensor" class="col-sm-2 control-label">Matrícula do agente</label>
                        <div class="col-sm-10">
                          <input id="matriculaAgenteApreensor" required v-model="data.matriculaAgenteApreensor"
                                 type="text" class="form-control"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="orgaoApreensor" class="col-sm-2 control-label">Órgão apreensor</label>
                        <div class="col-sm-10">
                          <select id="orgaoApreensor" required v-model="data.orgaoApreensor" class="form-control">
                            <option :value="null">Selecione</option>
                            <option :value="orgao.id" v-for="orgao in dataRequired.orgaoApreensor" :key="orgao.id">
                              {{orgao.nome}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Outras Informações</titulo-secao>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="numeroAutoInfracao" class="col-sm-2 control-label">Nº auto de infração</label>
                        <div class="col-sm-10">
                          <input id="numeroAutoInfracao" required v-model="data.numeroAutoInfracao" type="text"
                                 class="form-control"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="codigoInfracao" class="col-sm-2 control-label">Motivo da Apreensão (código da infração)</label>
                        <div class="col-sm-10">
                          <input id="codigoInfracao" required v-model="data.codigoInfracao" type="text" class="form-control" ref="codigoInfracao" maxlength="8"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="motivoInfracaoOutros" class="col-sm-2 control-label">Motivo outros</label>
                        <div class="col-sm-10">
                          <input id="motivoInfracaoOutros" v-model="data.motivoInfracaoOutros" type="text"
                                 class="form-control"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="tipoRemocao" class="col-sm-2 control-label">Tipo de remoção</label>
                        <div class="col-sm-10">
                          <select id="tipoRemocao" v-model="data.tipoRemocao" class="form-control">
                            <option :value="1">Conduzido</option>
                            <option :value="2">Rebocado</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="tipoOperacao" class="col-sm-2 control-label">Tipo operação</label>
                        <div class="col-sm-10">
                          <select id="tipoOperacao" v-model="data.tipoOperacao" class="form-control">
                            <option :value="1">Remoção</option>
                            <option :value="2">Apreensão</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="volumesInteriorVeiculo" class="col-sm-2 control-label">Volumes ou acessórios no
                          interior do
                          veículo</label>
                        <div class="col-sm-10">
                          <input id="volumesInteriorVeiculo" v-model="data.volumesInteriorVeiculo" type="text"
                                 class="form-control"/>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" id="comRubrica" v-model="data.comRubrica" tabindex="0"
                                   aria-checked="false" aria-invalid="false"><i></i>
                          </label>
                          <label for="comRubrica">Com Rúbrica</label>
                        </div>
                      </div><!---->
                    </div>
                  </div>

                  <titulo-secao>Observações</titulo-secao>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="observacoes" class="col-sm-2 control-label">Observações</label>
                        <div class="col-sm-10">
                          <textarea id="observacoes" v-model="data.observacoes" rows="7" class="form-control" style="resize: none;"></textarea>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" id="comAssinaturaCondutor" v-model="data.comAssinaturaCondutor"
                                   tabindex="0" aria-checked="false" aria-invalid="false"><i></i>
                          </label>
                          <label for="comAssinaturaCondutor">Com assinatura do condutor</label>
                        </div>
                      </div><!---->

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" id="comAssinaturaTestemunha" v-model="data.comAssinaturaTestemunha"
                                   tabindex="0" aria-checked="false" aria-invalid="false"><i></i>
                          </label>
                          <label for="comAssinaturaTestemunha">Com assinatura da testemunha</label>
                        </div>
                      </div><!---->

                      <div class="form-group">
                        <div class="col-sm-offset-2 col-sm-10">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" id="condutorPresente" v-model="data.condutorPresente" tabindex="0"
                                   aria-checked="false" aria-invalid="false"><i></i>
                          </label>
                          <label for="condutorPresente">Condutor presente</label>
                        </div>
                      </div><!---->
                    </div>
                  </div>

                  <titulo-secao v-if="isGgv">Parecer Final</titulo-secao>

                  <div class="wrapper-md m-b-lg" v-if="isGgv">
                    <div class="row">
                      <label class="col-sm-4 control-label">Em conformidade com a GRV</label>
                      <div class="col-sm-8">
                        <select v-model="ggv.conforme" class="form-control">
                          <option :value="true">Conforme</option>
                          <option :value="false">Não conforme</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Lacres</titulo-secao>
                  <lacres-grv :lacres="data.lacres" :restrito-visitante="isRestritoVisitante"></lacres-grv>

                  <titulo-secao>
                    Arquivos para GRVs <small v-if="isFromSolicitacao">(As fotos da solicitação de remoção serão utilizadas automaticamente)</small>
                  </titulo-secao>
                  <arquivos-grv :arquivos="data.arquivos" :tipos-arquivo="dataRequired.tipoArquivo" :restrito-visitante="isRestritoVisitante"></arquivos-grv>

                  <div class="wrapper" v-if="!isGgv">
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv" v-if="!isRestritoVisitante">Salvar</button>
                      </div>
                    </div>
                  </div>
                  <div class="wrapper" v-else>
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-block btn-lg">Confirmar GGV</button>
                        <div class="text-center">
                          * a confirmação inclui imeditamente este bem no pátio e transmite as informações para o DETRO
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.form-grv label {
  cursor: pointer;
}

.btn-colsultaGrv {
  padding-top: 7px;
  padding-bottom: 7px;
}
</style>



// WEBPACK FOOTER //
// Grv.vue?41b29d65